export default {
  methods: {
    setFocus(e) {
      const firstEl = document.querySelector('[data-tab-order=first]');
      const lastEl = document.querySelector('[data-tab-order=last]');
      if (firstEl && lastEl) {
        if (e.keyCode === 9 && !e.shiftKey && document.activeElement === lastEl) {
          e.preventDefault();
          firstEl.focus();
        }
        if (e.keyCode === 9 && e.shiftKey && document.activeElement === firstEl) {
          e.preventDefault();
          lastEl.focus();
        }
      } else if (e.keyCode === 9) {
        e.preventDefault();
      }
    },
  },
};
